import type { SVGProps } from "react";

export function IconBlackHeadset(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.75 8.25H5.79454C6.16505 5.15183 8.80204 2.75 12 2.75C15.198 2.75 17.8349 5.15183 18.2055 8.25H15.25V16.75H18.25V18C18.25 19.7949 16.7949 21.25 15 21.25H12.25V22.75H15C17.6234 22.75 19.75 20.6234 19.75 18V16.684C21.7395 16.3298 23.25 14.5913 23.25 12.5C23.25 10.3981 21.7242 8.65262 19.7198 8.3107C19.371 4.35339 16.0479 1.25 12 1.25C7.95209 1.25 4.62901 4.35339 4.28024 8.3107C2.27582 8.65262 0.75 10.3981 0.75 12.5C0.75 14.5913 2.26049 16.3298 4.25 16.684V9C4.25 8.7677 4.26022 8.53779 4.28024 8.3107C4.51419 8.27079 4.75467 8.25 5 8.25H5.79454C5.76513 8.4959 5.75 8.74618 5.75 9V16.75H8.75V8.25ZM19.7198 8.3107C19.7398 8.53779 19.75 8.7677 19.75 9V16.684C19.5065 16.7274 19.2559 16.75 19 16.75H18.25V9C18.25 8.74618 18.2349 8.4959 18.2055 8.25H19C19.2453 8.25 19.4858 8.27079 19.7198 8.3107Z"
        fill="#0B0C17"
      />
    </svg>
  );
}
